import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'threat-knowledge',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './threat-knowledge.component.html',
  styleUrl: './threat-knowledge.component.css'
})
export class ThreatKnowledgeComponent implements OnInit, OnChanges {

  @Input() teacherStaffInterviewData: any;
  @Output() onSaveSection2 = new EventEmitter<any>();

  yesNo = EYesNo;
  threatKnowledgeForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What do you know about the threatening situation prompting this review? *",
      formControlName: "knowledge_of_threat",
    }
  ]

  radioQuestions = [
    {
      id: 'student_violence',
      questionText: 'Have you heard this student talk about violence, threats or dangerous behavior? *',
      formControlName: 'student_violence',
      infoFormControlName: 'student_violence_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['teacherStaffInterviewData'] && this.teacherStaffInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};

    this.radioQuestions.forEach(question => {
      const defaultValue = this.teacherStaffInterviewData && this.teacherStaffInterviewData[question.formControlName] !== undefined
                           ? this.teacherStaffInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.teacherStaffInterviewData?.[question.infoFormControlName] || '', disabled: this.teacherStaffInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.teacherStaffInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.threatKnowledgeForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.threatKnowledgeForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.threatKnowledgeForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === this.yesNo.Yes);
          }
        });
      }
    });
  }  

  saveThreatKnowledge(): void {
    if (this.threatKnowledgeForm.valid) {
      this.onSaveSection2.emit(this.threatKnowledgeForm.value);
    }
  }

}
